<template>
    <div class="investment-activity-tab p-xl bg-stone-300 w-100">
        <p class="extra-small uppercase text-primary font-bold">
            Understanding Investment Activity
        </p>
        <h4 class="text-stone-800">
            Investor Confidence: A Deep Dive into Investment Types and Trends
        </h4>
        <AonCard
            class="mt-md"
            title="Types of Investments"
            :desc="`Understanding the types of investments in ${props.nodeData.displayName} reveals the market's maturity and future potential.`"
        >
            <InvestmentsByYear :nodeData="props.nodeData" :type="props.type" />
            <InvestmentAndValuation :nodeData="props.nodeData" :type="props.type" />
            <TopInvestors :nodeData="props.nodeData" :type="props.type" />
        </AonCard>
    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { useEntityStore } from '@/stores'

import InvestmentsByYear from './InvestmentsByYear.vue'
import InvestmentAndValuation from './InvestmentAndValuation.vue'
import TopInvestors from './TopInvestors.vue'

const entityStore = useEntityStore()

const props = defineProps({
    nodeData: {
        type: Object,
        default: () => {},
    },
    type: {
        type: String,
        default: 'pa',
    },
})
</script>
